var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"ma-3"},[_vm._v(" Table of Contents ")]),_c('regulation-toc',{attrs:{"requirements":_vm.requirements},on:{"requirement-selected":_vm.scrollToRequirementKey}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }